export const indexActionTypes = {
    INDEX_UPDATEDATA: "INDEX_UPDATEDATA",
    INDEX_UPDATECHARTDATA: "INDEX_UPDATECHARTDATA",
    INDEX_UPDATEBASKETINDEX: "INDEX_UPDATEBASKETINDEX",
    INDEX_UPDATESTATISTICCHART: "INDEX_UPDATESTATISTICCHART",
    INDEX_UPDATEDERIVATIVECHART: "INDEX_UPDATEDERIVATIVECHART"
}

export const updateIndexInfos = (newInfos, isInit) => {
    return {
        type: indexActionTypes.INDEX_UPDATEDATA,
        payload: { data: newInfos, isInit: isInit}
    }
};

export const updateIndexChart = (newInfos) => {
    return {
        type: indexActionTypes.INDEX_UPDATECHARTDATA,
        payload: newInfos
    }
};

export const updateBasketIndex = (basketIndex) => {
    return {
        type: indexActionTypes.INDEX_UPDATEBASKETINDEX,
        payload: basketIndex
    }
}

export const updateStatisticChart = (statisticChart) => {
    return {
        type: indexActionTypes.INDEX_UPDATESTATISTICCHART,
        payload: statisticChart
    }
}

export const updateDerivativeChart = (derivativeChart) => {
    return {
        type: indexActionTypes.INDEX_UPDATEDERIVATIVECHART,
        payload: derivativeChart
    }
}